/**
 * i18n module entry point.
 * Exports language types, translation dictionaries, and helpers.
 */
import en from './en';
import zh from './zh';

/** Supported language codes. */
export type Language = 'en' | 'zh';

/**
 * Recursively widens `as const` literal string types to `string`
 * while preserving the nested object structure for key resolution.
 */
type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>;
};

/** Translation structure derived from the English file (source of truth for keys). */
export type Translations = DeepStringRecord<typeof en>;

/** Map of language code to translation object. */
export const translations: Record<Language, Translations> = {
  en,
  zh,
};

export { en, zh };
